import { useEffect, useState } from 'react'
import { RouterProvider } from 'react-router'

import { CircularProgress, Stack } from '@mui/material'
import CssBaseline from '@mui/material/CssBaseline'

import { ListDialogProvider } from './components/ListDialog/ListDialog'
import { ConsoleThemeProvider } from './contexts/theme/themeContext'
import { router } from './router/router'
import { initializeKeycloakIfNeeded } from './service/authService'

export function App() {
  const [isInitializing, setIsInitializing] = useState(true)

  useEffect(() => {
    const initialize = async () => {
      await initializeKeycloakIfNeeded()

      setIsInitializing(false)
    }

    initialize()
  }, [])

  if (isInitializing) {
    return (
      <ConsoleThemeProvider>
        <CssBaseline />
        <Stack alignItems="center" justifyContent="center" sx={{ height: '100vh', width: '100vw' }}>
          <CircularProgress size={60} />
        </Stack>
      </ConsoleThemeProvider>
    )
  }

  return (
    <ConsoleThemeProvider>
      <ListDialogProvider>
        <CssBaseline />
        <RouterProvider router={router} />
      </ListDialogProvider>
    </ConsoleThemeProvider>
  )
}
